import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

export interface CompanyInvoiceScansObject {
  companyId: number;
  attachmentCount: number;
  usesOcr: boolean;
}

export type CompanyInvoiceScans = CompanyInvoiceScansObject[];

const useCompanyInvoiceScansApi = (immediate: boolean = true) => {
  const call = useCallback(async () => {
    try {
      const res = await axiosInstance.get<CompanyInvoiceScans>(api.companyInvoiceScans);
      return res.data;
    } catch (error) {
      console.error(error);
      return [];
    }
  }, []);
  const { value, execute } = useAsync(call, immediate);

  return { companyInvoiceScans: value || [], getCompanyInvoiceScans: execute };
};

export default useCompanyInvoiceScansApi;
